<template>
	<div class="fondo">
		<div class="login">
			<div id="login-box" class="col-md-12">
				<form id="login-form" class="form" @submit.prevent="login">
					<h3 class="text-center">Login</h3>
					<div class="form-group">
						<label for="username" >Usuario:</label><br>
						<input type="text" v-model="username" name="username" id="username" class="form-control">
					</div>
					<div class="form-group">
						<label for="password">Clave</label><br>
						<input type="password" v-model="password" name="password" id="password" class="form-control">
					</div>                           
					<div class="form-group">
						<label for="remember-me">
						<span>Recuérdame </span>
						<span><input id="remember-me" name="remember-me" type="checkbox"></span></label><br>
						<input name="submit" native-type="submit" class="btn btn-success btn-md" value="Enviar" v-on:click="login()">
					</div>
					<div class="form-group mensaje">{{ mensaje }}</div>
				</form>
			</div>               
		</div>
	</div>
</template>
<script lang="ts">

	import Vue from "vue"
	import axios from "axios"


	export default 
	{
		name: "Login",
		props: {
			onLogin: Function, // Funcion callback asociada a la accion de Login
		},
		data () {
			return {
				username: "",
				password: "",
				mensaje: "",
			}
		},
		methods:{
        
			login()
			{
				const { username, password } = this;
				var request = {
					"tx": "BS0",
					"query": { "query": { "bool": { "must": [ { "term": { "usuario.keyword": username } } ] } } }
				};
            
				axios.post("/face", request, { headers: { "Content-Type": "text/plain"} }).then(response => { 

					var respuesta = response.data.data[4];
					if (password === respuesta.contraseña) {

						// Guardamos el login para usarlo en las llamadas a la api
						Vue.prototype.$usuario = this.username 

						// Llamamos a la funcion callback
						if (this.onLogin)
							this.onLogin(true)
					} else
						this.mensaje="Usuario o clave incorrectos...";
                
				}).catch(ex => { console.log(ex) })
			}
		},    
		mounted() {},
	}
</script>
<style scoped>

	.fondo {
		height: 100%;
		width: 100%;
		background-image: url(/images/fondo.jpg);
	}

	.mensaje{
		color: yellow;
		font-size: 20px;
	}

	.btn-md {
		width: 100%;
	}

	.login #login-box {
		margin-top: 0px;
		max-width: 600px;
		border: 1px solid rgb(130, 130, 130);
		background: #737677;
		color: white;
		position: fixed;
		width: 25%;
		top:15%;
		left: 37%;
		z-index: 1;
	}

	.login #login-box #login-form {
		padding: 20px;
	}

	.login #login-box #login-form #register-link {
		margin-top: -85px;
	}

	.log{
		margin-top:30px;
		margin-bottom: 40px
	}
</style>
